<div class="sidebar-collapse">
  <ul class="nav metismenu">
    <li ng-if="permissions.depositos.canRead" ng-class="isActive('/depositos_padrao', '/depositos')">
      <a ng-href="{{parametros.utiliza_deposito_padrao ? '#!/depositos_padrao' : '#!/depositos'}}">
        <i class="fa fa-industry"></i>
        <span class="nav-label">
          Depósitos
        </span>
      </a>
    </li>

    <li ng-if="permissions.itens_estoque.canRead && currentPropriedade" ng-class="isActive('/itens_estoque')">
      <a href="#!/itens_estoque">
        <i class="fa fa-archive"></i>
        <span class="nav-label">
          Itens de estoque
        </span>
      </a>
    </li>

    <li ng-if="permissions.maquina.canRead && currentPropriedade" ng-class="isActive('/maquinas')">
      <a href="#!/maquinas">
        <i class="icon-fulltrator"></i>
        <span class="nav-label">
          Máquinas
        </span>
      </a>
    </li>

    <li ng-if="permissions.propriedades.canRead" ng-class="isActive('/cadastro_propriedades')">
      <a ng-href="#!/cadastro_propriedades">
        <i class="fa fa-globe"></i>
        <span class="nav-label">
          Propriedades
        </span>
      </a>
    </li>

    <li ng-if="$root.parametros.nao_cliente_agrogestao && permissions.safras.canRead" ng-class="isActive('/safras')">
      <a ng-href="#!/safras">
        <i class="glyphicon glyphicon-time"></i>
        <span class="nav-label">
          Safras
        </span>
      </a>
    </li>

    <li ng-if="$root.parametros.nao_cliente_agrogestao && permissions.estadios_fenologicos.canRead">
      <a ng-href="#!/estadios_fenologicos">
        <i class="glyphicon glyphicon-grain"></i>
        <span class="nav-label">
          Estádios Fenológicos
        </span>
      </a>
    </li>

    <li ng-if="permissions.glebas.canRead" ng-class="isActive('/glebas')">
      <a ng-href="#!/glebas">
        <i class="icon-layer"></i>
        <span class="nav-label">
          Talhões
        </span>
      </a>
    </li>

    <li ng-if="$root.parametros.nao_cliente_agrogestao && permissions.colheitas.canRead && currentPropriedade" ng-class="isActive('/colheitas')">
      <a ng-href="#!/colheitas">
        <i class="glyphicon glyphicon-apple"></i>
        <span class="nav-label">
          Colheitas
        </span>
      </a>
    </li>

    <li ng-if="permissions.clima.integracaoPluviometros" ng-class="isActive('/integracao_pluviometros')">
      <a ng-href="#!/integracao_pluviometros">
        <i class="icon-weatherfill"></i>
        <span class="nav-label">
          Integração Pluviômetros
        </span>
      </a>
    </li>

    <li ng-if="permissions.tipos_ocorrencia.canRead" ng-class="isActive('/tipos_ocorrencias')">
      <a ng-href="#!/tipos_ocorrencias">
        <i class="icon-ocurrences"></i>
        <span class="nav-label">
          Tipos de Ocorrências
        </span>
      </a>
    </li>

    <li ng-if="currentPropriedade && permissions.parametro.canManage" ng-class="isActive('/plantios')">
      <a href="#!/plantios">
        <i class="icon-semeadura"></i>
        <span class="nav-label">
          Plantios
        </span>
      </a>
    </li>

    <li ng-if="currentPropriedade && $root.isMasterUser()" ng-class="isActive('/delete-data')">
      <a href="#!/delete-data">
        <i class="fa fa-trash"></i>
        <span class="nav-label">
          Apagar dados
        </span>
      </a>
    </li>

    <li class="item-divider" ng-if="permissions.usuario.canRead || permissions.funcao.canRead">
      <h3>Acessos</h3>
    </li>

    <li ng-if="permissions.usuario.canRead" ng-class="isActive('/usuarios')">
      <a href="#!/usuarios">
        <i class="fa fa-users"></i>
        <span class="nav-label">
          Usuários
        </span>
      </a>
    </li>

    <li ng-if="permissions.funcao.canRead" ng-class="isActive('/funcoes')">
      <a href="#!/funcoes">
        <i class="fa fa-shield"></i>
        <span class="nav-label">
          Permissões de Acesso
        </span>
      </a>
    </li>

    <li class="item-divider text-center" ng-if="!$root.currentPropriedade">
      <small>Selecione uma propriedade para exibir mais opções</small>
    </li>
  </ul>
</div>
